import NodeContentApiSerializer from 'rise-ui/serializers/apis/rise-api/content/node.js';

export default class PageSerializer extends NodeContentApiSerializer {}
